export default function CloudHoverText() {
  const clouds = $('.c-cloud')

  const init = () => {
    clouds.each(function () {
      const t = $(this)
      const hoverText = t.find('.c-cloud__hover-text')
      if (hoverText.length > 0) {
        t.on('mouseenter', function () {
          hoverText.addClass('active')
        })
        t.on('mouseleave', function () {
          hoverText.removeClass('active')
        })
      }
    })
  }

  return {
    init: init,
  }
}
